import axios from 'axios'

/**
 * The purpose of this mixin is to provide the `docPreviewUrl` URL which is used to show user the preview of the document
 *
 * @param updatePreviewCacheUrl - the URL which is requested when we need to update a document preview on a server.
 */
export function DocumentPreviewMixin ({ updatePreviewCacheUrl }) {
  return {
    data () {
      return {
        updateRequestCancelToken: null,
        docPreviewVersion: 0,
        baseDocPreviewUrl: null,
        updatePreviewRequestScheduled: false,
        isLastUpdatePreviewRequestFailed: false
      }
    },
    computed: {
      docPreviewUrl () {
        if (!this.baseDocPreviewUrl) {
          return null
        }
        return this.baseDocPreviewUrl + '?preview_version=' + this.docPreviewVersion
      },
      isDocumentPreviewAvailable () {
        return Boolean(this.docPreviewUrl)
      }
    },
    methods: {
      resetDocumentPreview () {
        this.docPreviewVersion = 0
        this.isLastUpdatePreviewRequestFailed = false
      },
      setBasePreviewUrl (url) {
        this.baseDocPreviewUrl = url
      },
      updateDocPreview (docData) {
        docData['preview'] = true
        this.isLastUpdatePreviewRequestFailed = false

        if (this.updateRequestCancelToken) {
          this.updateRequestCancelToken.cancel('Obsolete "document preview update" request canceled')
        }
        this.updateRequestCancelToken = axios.CancelToken.source()

        const docPreviewVersion = this.docPreviewVersion + 1

        axios
          .post(updatePreviewCacheUrl + docPreviewVersion, docData, {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            },
            cancelToken: this.updateRequestCancelToken.token
          })
          .then(() => {
            this.docPreviewVersion = docPreviewVersion
          })
          .catch(err => {
            if (axios.isCancel(err)) {
              return
            }

            console.error(err)

            this.isLastUpdatePreviewRequestFailed = true

            if (err.response?.data?.errors) {
              const errors = Object.values(err.response.data.errors)
              for (let i = 0; i < errors.length; i++) {
                this.$snotify.error(
                  errors[i][0],
                  'Error',
                  this.$store.state.snotify
                )
              }
            }
          })
          .finally(() => {
            this.updatePreviewRequestScheduled = false
          })
      }
    }
  }
}
